import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';

import { Observable } from 'rxjs';

import { SelectOption } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/common.type';
import { TrackByValue } from '@shared/types';
import { DropdownBaseComponent } from '@geniuspos/ui-shared/modules/xdm-shared-components/base-component/dropdown/dropdown-base.component';
import { rx } from '@shared/rx';

@Component({
  selector: 'xux-select-menu',
  templateUrl: 'xux-select-menu.component.html',
  styleUrls: ['xux-select-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxSelectMenuComponent
  extends DropdownBaseComponent
  implements AfterViewInit
{
  @Input() public setValue: Function;
  @Input() public showIcon: Function;
  @Input() public selectOptions$: Observable<SelectOption[]>;
  @Input() public trackByValue: TrackByValue;
  @Input() public icon: string;

  public ngAfterViewInit(): void {
    this.selectOptions$
      .pipe(
        rx.first(),
        // delay for rendering
        rx.delay(0),
      )
      .subscribe(() => {
        this.viewInit.emit();
      });
  }
}
